module.exports = __webpack_public_path__ + "img/ranking_img_four.85043283.png";